import { render, staticRenderFns } from "./CreateCashRegister.vue?vue&type=template&id=b6a0b88a&"
import script from "./CreateCashRegister.vue?vue&type=script&lang=js&"
export * from "./CreateCashRegister.vue?vue&type=script&lang=js&"
import style0 from "./CreateCashRegister.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports